import React, { useEffect } from 'react';
import { DifficultyHeader } from '../../constants/types';
import DifficultySummaryHomeItem from './DifficultySummaryHomeItem';

interface DifficultySummaryHomeProps {
    difficultyheaders: DifficultyHeader[];
    totalBoulderCount: number;
}

const DifficultySummaryHome: React.FC<DifficultySummaryHomeProps> = ({ difficultyheaders, totalBoulderCount }) => {
    const maxRatio = difficultyheaders.reduce((max, header) => {
        const currentRatio = header.countBoulder / totalBoulderCount;
        return currentRatio > max ? currentRatio : max;
    }, 0);

    useEffect(() => {
        const nameContainers = document.querySelectorAll('.difficulty-summary-item-container-name-container');
        let maxWidth = 0;

        nameContainers.forEach(container => {
            const width = container.getBoundingClientRect().width;
            if (width > maxWidth) {
                maxWidth = width;
            }
        });

        nameContainers.forEach(container => {
            (container as HTMLElement).style.width = `${maxWidth}px`;
        });
    }, [difficultyheaders]);

    return (
        <div className='flex flex-col items-start gap-3 w-full'>
            <div className='flex flex-row items-center gap-2 text-backoffice-800' style={{ marginBottom: '4px' }}>
                <div className='difficulty-summary-item-container-name-container' />
                <div className='bold large3 text-grey-600'>{totalBoulderCount > 1 ? `${totalBoulderCount} blocs` : `${totalBoulderCount} bloc`}</div>
            </div>

            {difficultyheaders && difficultyheaders
                .sort((a, b) => a.difficultyGrade - b.difficultyGrade)
                .map((difficultyheader, index) => {
                    const widthPercentage = ((difficultyheader.countBoulder / totalBoulderCount) / maxRatio) * 75;
                    return (
                        <div key={index} className='flex flex-row items-center gap-2 text-backoffice-800 w-full min-w-fit'>
                            <div className='difficulty-summary-item-container-name-container'>{difficultyheader.difficultyName}</div>
                            {difficultyheader.countBoulder !== 0 ?
                                <DifficultySummaryHomeItem
                                    difficultyheader={difficultyheader}
                                    totalRoutes={totalBoulderCount}
                                    width={`${widthPercentage.toFixed(2)}%`}
                                />
                                :
                                <div>Aucun bloc dans ce niveau</div>
                            }
                        </div>
                    );
                })}
        </div>
    );
}

export default DifficultySummaryHome;
